var render = function render(){
  var _vm$maintenanceDetail, _vm$maintenanceDetail2, _vm$maintenanceDetail3, _vm$maintenanceDetail4, _vm$maintenanceDetail5, _vm$maintenanceDetail6, _vm$maintenanceDetail7, _vm$maintenanceDetail8, _vm$maintenanceDetail9, _vm$maintenanceDetail0, _vm$maintenanceDetail1, _vm$maintenanceDetail10, _vm$maintenanceDetail11;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "border-bottom": "1px solid #dee2e6"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Status")]), _c('td', {
    staticClass: "font-medium"
  }, [_c('b-badge', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v(" " + _vm._s(_vm.maintenanceDetailData.status) + " ")])], 1)]), _c('tr', [_c('td', [_vm._v("Plan Maintenance")]), _c('td', {
    staticClass: "font-medium"
  }, [_vm._v(" " + _vm._s(_vm.formatDate(_vm.maintenanceDetailData.lastMaintenanceDate) || '-') + " ")])]), _c('tr', [_c('td', [_vm._v("Actual Maintenance")]), _c('td', {
    staticClass: "font-medium"
  }, [_vm._v(" " + _vm._s(_vm.maintenanceDetailData.actualMaintenanceDate || '-') + " ")])]), _c('tr', [_c('td', [_vm._v("Plan Maintenance (RH)")]), _c('td', {
    staticClass: "font-medium"
  }, [_vm._v(" " + _vm._s((_vm$maintenanceDetail = _vm.maintenanceDetailData.planMaintenanceRH) !== null && _vm$maintenanceDetail !== void 0 ? _vm$maintenanceDetail : '-') + " Hours ")])]), _c('tr', [_c('td', [_vm._v("Actual Maintenance (RH)")]), _c('td', {
    staticClass: "font-medium"
  }, [_vm._v(" " + _vm._s((_vm$maintenanceDetail2 = _vm.maintenanceDetailData.actualMaintenanceRH) !== null && _vm$maintenanceDetail2 !== void 0 ? _vm$maintenanceDetail2 : '-') + " Hours ")])]), _c('tr', [_c('td', [_vm._v("Cost")]), _c('td', {
    staticClass: "font-medium"
  }, [_vm._v(" Rp. " + _vm._s((_vm$maintenanceDetail3 = (_vm$maintenanceDetail4 = _vm.maintenanceDetailData.cost) === null || _vm$maintenanceDetail4 === void 0 ? void 0 : _vm$maintenanceDetail4.toLocaleString()) !== null && _vm$maintenanceDetail3 !== void 0 ? _vm$maintenanceDetail3 : '-') + " ")])]), _c('tr', [_c('td', [_vm._v("Attachment")]), _c('td', {
    staticClass: "font-medium"
  }, [_vm.maintenanceDetailData.file ? _c('ul', {
    staticClass: "profile-img-gallary d-flex flex-wrap p-0 m-0"
  }, [_c('li', {
    staticClass: "col-md-1 col-1 pb-1",
    on: {
      "click": function click($event) {
        return _vm.$emit('handleOpenFilePreview', _vm.maintenanceDetailData.file);
      }
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("../../../../assets/images/activity/pdf.png"),
      "alt": "gallary-image"
    }
  })])]) : _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("No File Exist..")])])]), _c('tr', [_c('td', [_vm._v("Notes")]), _c('td', {
    staticClass: "font-medium"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.maintenanceDetailData.notes)
    }
  }, [_vm._v(" " + _vm._s(_vm.maintenanceDetailData.notes || '-') + " ")])])]), (_vm$maintenanceDetail5 = _vm.maintenanceDetailData) !== null && _vm$maintenanceDetail5 !== void 0 && (_vm$maintenanceDetail6 = _vm$maintenanceDetail5.postpone) !== null && _vm$maintenanceDetail6 !== void 0 && _vm$maintenanceDetail6.length ? [_vm.maintenanceDetailData.trigger == 'CALENDAR' ? _c('tr', [_c('td', [_vm._v("Postponed Date")]), _c('td', {
    staticClass: "font-medium"
  }, [_vm._v(" " + _vm._s(_vm.formatDate((_vm$maintenanceDetail7 = _vm.maintenanceDetailData) === null || _vm$maintenanceDetail7 === void 0 ? void 0 : (_vm$maintenanceDetail8 = _vm$maintenanceDetail7.postpone) === null || _vm$maintenanceDetail8 === void 0 ? void 0 : _vm$maintenanceDetail8[0].extraDate) || '-') + " ")])]) : _c('tr', [_c('td', [_vm._v("Postponed (RH)")]), _c('td', {
    staticClass: "font-medium"
  }, [_vm._v(" " + _vm._s((_vm$maintenanceDetail9 = (_vm$maintenanceDetail0 = _vm.maintenanceDetailData) === null || _vm$maintenanceDetail0 === void 0 ? void 0 : (_vm$maintenanceDetail1 = _vm$maintenanceDetail0.postpone) === null || _vm$maintenanceDetail1 === void 0 ? void 0 : _vm$maintenanceDetail1[0].extraHours) !== null && _vm$maintenanceDetail9 !== void 0 ? _vm$maintenanceDetail9 : '-') + " Hours ")])]), _c('tr', [_c('td', [_vm._v("Postponed Notes")]), _c('td', {
    staticClass: "font-medium"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s((_vm$maintenanceDetail10 = _vm.maintenanceDetailData) === null || _vm$maintenanceDetail10 === void 0 ? void 0 : (_vm$maintenanceDetail11 = _vm$maintenanceDetail10.postpone) === null || _vm$maintenanceDetail11 === void 0 ? void 0 : _vm$maintenanceDetail11[0].notes)
    }
  })])])] : _vm._e()], 2)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }